/* src/app/pages/project/map/repository/import-wizard/components/geospatial/step0-kmz-kml-import-feature-list/components/feature-card/import-wizard-geospatial-feature-card.component.scss */
app-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.card-title {
  font-size: 0.88rem;
  flex: 1;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0 1rem;
}
.button-container > button {
  background: transparent;
  color: #FACC15;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: #FACC15;
  color: #2a2a2a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
.button-container > button:active {
  transform: translateY(0);
}
/*# sourceMappingURL=import-wizard-geospatial-feature-card.component-DJ6GVYLB.css.map */
